export const daysRanges = [30, 60, 90] as const;
export type DaysRange = typeof daysRanges[number];
